import React from 'react';
import { FormGroup, FormRadioGroup, Select } from '@snsw/react-component-library';
import styled from 'styled-components';

const Label = styled.div`
  width: 100%;
  color: #242934;
  font-weight: 500;
`;

const FormGroupOrg = styled(FormGroup)`
  margin-top: 4px;
`;

const SelectorContainer = styled.div`
  margin-bottom: 29px;
  max-width: 600px;
`;

const OrgFormRadioGroup = styled(FormRadioGroup)`
  margin-top: 4px;
  & > div {
    padding-top: 6px !important;
  }
`;

const OrganisationType = ({
  useSelect,
  disableABN,
  disableACN,
  disableYINC,
  disableOther,
  labels,
  typeError,
  setRegoType,
  regoType,
  id = 'organisationType-0',
}) => {
  const options = [];
  if (!disableABN) {
    options.push({ value: 'ABN', label: labels?.abn ?? 'ABN' });
  }

  if (!disableACN) {
    options.push({ value: 'ACN', label: labels?.acn ?? 'ACN' });
  }

  if (!disableYINC) {
    options.push({ value: 'YINC', label: labels?.yinc ?? 'Assoc. Incorporated Number' });
  }

  // Other is disabled by default
  if (typeof disableOther !== 'undefined' && !disableOther) {
    options.push({ value: 'Other', label: labels?.other ?? 'Other' });
  }
  const label = labels?.main || 'Registration type';

  return (
    <SelectorContainer>
      <Label>{label}</Label>
      {useSelect ? (
        <FormGroupOrg id={`${id}-${Math.random().toString()}`}>
          <Select
            value={regoType}
            onChange={(e) => {
              if (setRegoType) setRegoType(e.target.value);
            }}
            options={options.map((p) => ({
              value: p.value,
              text: p.label,
            }))}
          />
        </FormGroupOrg>
      ) : (
        <OrgFormRadioGroup
          errorMessage={'Registration Type is required'}
          hasError={typeError}
          id={'registrationType-' + Math.random().toString()}
          name={'registrationType-' + Math.random().toString()}
          onChange={(v) => {
            if (setRegoType) setRegoType(v);
          }}
          options={options}
          value={regoType}
        />
      )}
    </SelectorContainer>
  );
};
export default OrganisationType;
